import React from "react";
import { useField } from "formik";
import RangeInput from "../RangeInput";

const FormRangeInput = ({ name, onChange = null, onBlur = null, ...rest }) => {
  const [field, meta] = useField(name);

  const getError = () => {
    if (!meta.touched || !meta.error) return null;
    if (Array.isArray(meta.error)) return meta.error.join(", ");
    return meta.error;
  };

  return (
    <RangeInput
      name={name}
      value={field.value}
      onChange={onChange ?? field.onChange}
      onBlur={onBlur ?? field.onBlur}
      error={getError()}
      {...rest}
    />
  );
};

export default FormRangeInput;
